import { v4 as uuidv4 } from 'uuid';

export function genUuid() {
  return uuidv4();
}
